import axiosClient from "./axiosClient";

// Backend routes (axiosClient.baseURL already includes /api/v1):
//   GET    /roles
//   GET    /roles/{id}
//   POST   /roles
//   PUT    /roles/{id}
//   PUT    /roles/{id}/permissions
//   DELETE /roles/{id}
//   GET    /permissions   (catalog discovery)
const rolesApi = {
  list: () => axiosClient.get("/roles"),
  get: (id) => axiosClient.get(`/roles/${id}`),
  create: (payload) => axiosClient.post("/roles", payload),
  update: (id, payload) => axiosClient.put(`/roles/${id}`, payload),
  setPermissions: (id, permissions) =>
    axiosClient.put(`/roles/${id}/permissions`, { permissions }),
  remove: (id) => axiosClient.delete(`/roles/${id}`),

  // Permission catalog (grouped checkbox source for the editor)
  getPermissionCatalog: () => axiosClient.get("/permissions"),
};

export default rolesApi;